import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store';
import './mock/index.js';  // 该项目所有请求使用mockjs模拟
import './login.js'
import './ui.js'
// 定义全局变量
const GOODS_TYPE_OPTIONS = [
  { value: "特惠", label: "特惠" },
  { value: "3c产品", label: "3c产品" },
  { value: "潮玩手办", label: "潮玩手办" },
  { value: "家居日化", label: "家居日化" },
  { value: "美妆个护", label: "美妆个护" },
  { value: "家电", label: "家电" },
  { value: "其他精品", label: "其他精品" },
  { value: "套餐活动", label: "套餐活动" },
];
Vue.prototype.$goodsTypeOptions = GOODS_TYPE_OPTIONS;

Vue.config.productionTip = false;
var vm = new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})


